import React from 'react';
import { useHistory } from 'react-router';

// API
import { requestAssistantDemoClick } from 'Shared/api';

// Images
import SalesforceLogo from 'Shared/images/salesforce-logo.svg';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle, WpPageUtilityNavBar } from 'Wpds/components/page-layout';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

// Styles
import './ConnectSalesAssistant.scss';

const ConnectSalesAssistants = () => {
  const history = useHistory();

  const onRequestDemo = () => {
    requestAssistantDemoClick({ assistantType: 'Sales Assistant' });
  };

  const handleBackToAssisstantsPageClick = () => {
    history.push(PageUrls.ASSISTANTS_PAGE);
  };

  const baseClassName = 'ConnectSalesAssistants';

  return (
    <WpPageLayout width="container" className="ConnectSalesAssistants">
      <WpPageUtilityNavBar>
        <WpButton size="sm" variant="tertiary" onClick={handleBackToAssisstantsPageClick}>
          <WpIcon name="angle-left" />
          Assistants
        </WpButton>
      </WpPageUtilityNavBar>
      <WpPageHeader>
        <WpPageTitle
          title="Sales Assistant"
          subTitle="Automate repetitive work for you and your reps by automatically generating action items based on their
         Salesforce data"
        />
      </WpPageHeader>
      <WpPageBody className={`${baseClassName}__body`}>
        <EmptyStateContainer
          title="Get started by connecting your Salesforce"
          subTitle="We use your Salesforce data to give you relevent alerts when your data is out of sync."
        />
        <div className={`${baseClassName}__button-wrapper`}>
          <WpButtonGroup stacked>
            <WpButton size="lg" block>
              <img className={`${baseClassName}__logo-img`} src={SalesforceLogo} />
              Connect Salesforce
            </WpButton>
            <WpButton variant="secondary" size="lg" block onClick={onRequestDemo}>
              Request a Demo
            </WpButton>
          </WpButtonGroup>
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default ConnectSalesAssistants;
